import { render, staticRenderFns } from "./ContactsSituation.vue?vue&type=template&id=df57ec08&scoped=true"
import script from "./ContactsSituation.vue?vue&type=script&lang=js"
export * from "./ContactsSituation.vue?vue&type=script&lang=js"
import style0 from "./ContactsSituation.vue?vue&type=style&index=0&id=df57ec08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df57ec08",
  null
  
)

export default component.exports